const wordCounter = (count, word) =>
  count && word ? `${count} ${word}${count === 1 ? '' : 's'}` : '';

export default wordCounter;
